"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENV_AASHISH = exports.ENV_CLEMENT = exports.ENV_ERWAN = exports.ENV_SURBHI = exports.ENV_TOMMY = exports.ENV_BINIT = exports.ENV_LATHA = exports.ENV_MARION = exports.ENV_ABHIJIT = exports.ENV_LOCAL_WITH_BE = exports.ENV_LOCAL = exports.ENV_DEVELOP = exports.ENV_BETA = exports.ENV_HOTFIX = exports.ENV_RELC = exports.ENV_PRODUCTION = void 0;
exports.ENV_PRODUCTION = 'production';
exports.ENV_RELC = 'relc';
exports.ENV_HOTFIX = 'hotfix';
exports.ENV_BETA = 'beta';
exports.ENV_DEVELOP = 'develop';
exports.ENV_LOCAL = 'local';
exports.ENV_LOCAL_WITH_BE = 'local-be';
exports.ENV_ABHIJIT = 'abhijit';
exports.ENV_MARION = 'marion';
exports.ENV_LATHA = 'latha';
exports.ENV_BINIT = 'binit';
exports.ENV_TOMMY = 'tommy';
exports.ENV_SURBHI = 'surbhi';
exports.ENV_ERWAN = 'erwan';
exports.ENV_CLEMENT = 'clement';
exports.ENV_AASHISH = 'aashish';
